import { render } from "./AutomationModalUpdateVersion.vue?vue&type=template&id=157514f5&scoped=true"
import script from "./AutomationModalUpdateVersion.vue?vue&type=script&lang=js"
export * from "./AutomationModalUpdateVersion.vue?vue&type=script&lang=js"

import "./AutomationModalUpdateVersion.vue?vue&type=style&index=0&id=157514f5&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157514f5"]])

export default __exports__